export const formatErrorMessage = (error: any, defaultMessage: string = "unknown error"): string => {
    const data = error?.response?.data || error?.data;
    const violations = data?.violations;
    return (((violations?.length || 0) > 0 && violations[0].message) ||
        data?.detail ||
        data?.["hydra:description"] ||
        data?.message ||
        defaultMessage) as string;
};

export default formatErrorMessage;
